import {
  CompleteMultipartUploadDto,
  MultipartUploadControllerAbortUploadParams,
  MultipartUploadControllerGetPartsUploadPAramsParams,
  MultipartUploadControllerListPartsParams
} from '@api/Api';
import { apiClient } from '@api/client';

export const multipartUploadComplete = (data: CompleteMultipartUploadDto) =>
  apiClient.multipartUpload.multipartUploadControllerCompleteUpload(data);

export const multipartUploadAbort = (
  params: MultipartUploadControllerAbortUploadParams
) => apiClient.multipartUpload.multipartUploadControllerAbortUpload(params);

export const multipartUploadParts = (
  params: MultipartUploadControllerListPartsParams
) => apiClient.multipartUpload.multipartUploadControllerListParts(params);

export const multipartUploadPartsUploadParams = (
  params: MultipartUploadControllerGetPartsUploadPAramsParams
) =>
  apiClient.multipartUpload.multipartUploadControllerGetPartsUploadPArams(
    params
  );
